import { Card, CardContent, Typography } from '@mui/material'
import React from 'react'
import { AirlineSeatReclineNormal, DateRangeOutlined, SupervisorAccountOutlined } from '@mui/icons-material'

interface RecentSearchBlockProps {
    from: string
    to: string
    fromCity?: string
    toCity?: string
    tripType: string
    departDate: string
    returnDate: string
    totalTraveler: number
    travelClass: string
    isSinglePerson: boolean
    travellerLabel: string
    onClick?: () => void
}

const RecentSearchBlock: React.FC<RecentSearchBlockProps> = ({
    from,
    to,
    fromCity,
    toCity,
    tripType,
    departDate,
    returnDate,
    totalTraveler,
    travelClass,
    isSinglePerson,
    travellerLabel,
    onClick
}) => {
    return (
        <Card
            sx={{
                cursor: 'pointer',
                position: 'relative',
                boxShadow: 'rgba(0, 0, 0, 0.04) 0px 8px 16px',
                border: '1px solid #e6e6e6',
                '&:hover': {
                    boxShadow: 'rgba(0, 0, 0, 0.08) 0px 12px 20px',
                    transform: 'translateY(-2px)',
                    transition: 'all 0.2s ease-in-out'
                }
            }}
            onClick={onClick}
        >
            <CardContent sx={{ p: 2, pt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {tripType}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.primary',
                        fontWeight: 500,
                        mb: 1
                    }}
                >
                    {fromCity && toCity ? `${fromCity} → ${toCity}` : `${from} → ${to}`}
                </Typography>

                <Typography
                    variant="body2"
                    color="text.primary"
                    sx={{ mb: 1, gap: '2px', display: 'flex', alignItems: 'center' }}
                >
                    <DateRangeOutlined sx={{ fontSize: 16 }} />{' '}
                    {`${departDate}${returnDate ? ` - ${returnDate}` : ''}`}{' '}
                </Typography>
                <Typography
                    variant="body2"
                    color="text.primary"
                    sx={{ mb: 1, gap: '2px', display: 'flex', alignItems: 'center' }}
                >
                    <SupervisorAccountOutlined sx={{ fontSize: 16 }} />{' '}
                    {`${totalTraveler} ${travellerLabel}`}
                    <AirlineSeatReclineNormal sx={{ fontSize: 16, ml: 0.5 }} />
                    {`${travelClass}`}
                </Typography>
            </CardContent>
        </Card>
    )
}

export { RecentSearchBlock }
export type { RecentSearchBlockProps }

